import { render, staticRenderFns } from "./dataInput.vue?vue&type=template&id=51a20008&scoped=true&"
import script from "./dataInput.vue?vue&type=script&lang=js&"
export * from "./dataInput.vue?vue&type=script&lang=js&"
import style0 from "./dataInput.vue?vue&type=style&index=0&id=51a20008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a20008",
  null
  
)

export default component.exports